import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { ScanStationUpdateAllRequest } from "./ScanStationUpdateAllRequest";
import { ScanStationPrefRequest } from "./ScanStationPrefRequest";

@Injectable()
export class DataService_ScanStationTrackingSU {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	//INSERT CUSTOM METHODS HERE
	ScanStationTrackingSUColumnOptionSelectList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationTrackingSUColumnOptionSelectList?";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationTrackingSUSelectList(FacilityID, Active) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationTrackingSUSelectList?FacilityID=" + FacilityID + "&Active=" + Active;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	FacilitySelectList(SchoolID) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/GetSchoolFacilities?SchoolID=" + SchoolID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationDecomissionUpdate(ScanStationID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationDecomissionUpdate?ScanStationID=" + ScanStationID + "&ChangeTo=" + ChangeTo;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationEntryModeUpdate(ScanStationID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationEntryModeUpdate?ScanStationID=" + ScanStationID + "&ChangeTo=" + ChangeTo;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationExitModeUpdate(ScanStationID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationExitModeUpdate?ScanStationID=" + ScanStationID + "&ChangeTo=" + ChangeTo;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationMealModeUpdate(ScanStationID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationMealModeUpdate?ScanStationID=" + ScanStationID + "&ChangeTo=" + ChangeTo;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationAccessModeUpdate(ScanStationID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationAccessModeUpdate?ScanStationID=" + ScanStationID + "&ChangeTo=" + ChangeTo;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationTimeStampModeUpdate(ScanStationID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationTimeStampModeUpdate?ScanStationID=" + ScanStationID + "&ChangeTo=" + ChangeTo;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationEventModeUpdate(ScanStationID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationEventModeUpdate?ScanStationID=" + ScanStationID + "&ChangeTo=" + ChangeTo;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationUpdateAll(parms: ScanStationUpdateAllRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationUpdateAll";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationRebuildUpdate(ScanStationID, ChangeTo) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationRebuildUpdate?ScanStationID=" + ScanStationID + "&ChangeTo=" + ChangeTo;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	UpdateScanStationPref(parms: ScanStationPrefRequest) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/UpdateScanStationPref";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationSUFacilityOptionSelectList() {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationSUFacilityOptionSelectList";
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	ScanStationSUFacilityLocationOptionSelectList(FacilityID: number) {
		var postResult$ = new Subject();
		var url = "DistrictAdministration/ScanStationSUFacilityLocationOptionSelectList?FacilityID=" + FacilityID;
		//console.log(url);

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
